import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledButtonGradientTopVoice = styled('div')`
  padding: 4px 8px;
  width: max-content;
  background: transparent;
  border: none;
  color: transparent;
  font-size: 12px;
  height: 24px;
  line-height: 16px;
  box-sizing: border-box;
  background-clip: text;
  -webkit-background-clip: text;
  background-image: ${({ color }) => color};
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  letter-spacing: -0.4px;
  text-align: center;
  vertical-align: middle;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 8px;
    padding: 2px;
    background: ${({ border }) => border};

    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    z-index: 1;
  }
`;

export const StyledVoicePopover = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;
  box-shadow: 0px 4px 16px 0px ${COLOR.black[8]};
  padding: 16px;
  background-color: ${COLOR.white.default};
  border: 0.5px solid ${COLOR.indigo[16]};
  max-width: 320px;
  min-width: 320px;

  .avatar-badge-icon {
    width: 16px;
    height: 16px;
  }

  .popover-header {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .button-gradient-top-container {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .popover-stat {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .popover-description {
    word-break: break-word;
  }
  .popover-retention-days-label {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;
